// Switches the language as soon as one is chosen in the language selector.
// A single listener on the document, so it also works on selectors added later.
document.addEventListener('change', function (event) {
  var select = event.target.closest('[data-language-select]');
  if (select && select.form) {
    select.form.submit();
  }
});
